// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { convertLogesToRencontreFilter } from 'utils/convertUtils';
import { getPlaceholder } from 'utils/assetsUtils';

import type { LogeListType, LogeRencontreType } from 'types/LogeList';

type Props = {
  id: string,
  label: string,
  loges: Array<LogeListType>,
  inputChanged: (value: number, label?: string) => void,
  headTitle: string,
  big?: boolean,
};

type State = {
  isOpen: boolean,
  matchSelected: number | null,
};

class DropdownMatch extends PureComponent<Props, State> {
  props: Props;

  state: State = {
    isOpen: false,
    matchSelected: null,
  };

  wrapperRef: any;

  static defaultProps = {
    id: 'ID',
    label: 'Label',
    options: [
      {
        value: 'option1',
        label: 'option1'
      }
    ],
  };

  _getRencontreTitle = (rencontre: LogeRencontreType) => {
    const { adversaire, reception } = rencontre;

    if (reception) {
      return `France / ${adversaire}`;
    }

    return `${adversaire} / France`;
  }

  _renderOptions = () => {
    const { loges } = this.props;
    const rencontres = convertLogesToRencontreFilter(loges);

    return rencontres.map<any>(rencontre => {
      const { id, adversaire, adversaire_logo, france_logo, reception, date_rencontre, equipe } = rencontre;
      const rencontreTitle = this._getRencontreTitle(rencontre);

      let rencontreContent = (
        <div>
          <img
            className="is-inline"
            src={adversaire_logo ? adversaire_logo : getPlaceholder()}
            alt={`Logo rugby ${adversaire}`}
            width="40"
            height="40"/>
          <span className="ft-black-secondary ft-700 ft-tertiary">/</span>
          <img
            className="is-inline"
            src={france_logo ? france_logo : getPlaceholder()}
            alt={`Logo ${equipe ? equipe : 'XV de France'}`}
            width="40"
            height="40" />
        </div>
      );

      if (reception) {
        rencontreContent = (
          <div>
            <img
              className="is-inline"
              src={france_logo ? france_logo : getPlaceholder()}
              alt={`Logo ${equipe ? equipe : 'XV de France'}`}
              width="40"
              height="40" />
            <span className="ft-black-secondary ft-700 ft-tertiary">/</span>
            <img
              className="is-inline"
              src={adversaire_logo ? adversaire_logo : getPlaceholder()}
              alt={`Logo rugby ${adversaire}`}
              width="40"
              height="40"/>
          </div>
        );
      }

      return (
        <div
          key={id}
          onClick={() => this.handleSelected(parseInt(id, 10))}
          className="card card--match"
          role='button'
          tabIndex={0}>
          <div>
            <span className="ft-h6 ft-up ft-red">{equipe}</span>
            <p className="ft-primary mb-0">{rencontreTitle}</p>
            <span className="ft-h6 ft-up ft-black-secondary">{date_rencontre}</span>
          </div>
          {rencontreContent}
        </div>
      );
    });
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  _renderLabel = () => {
    const { label } = this.props;
    const { matchSelected } = this.state;

    if (matchSelected) {
      const { loges } = this.props;
      const rencontres = convertLogesToRencontreFilter(loges);
      const rencontreSelected = rencontres.filter((rencontre) => rencontre.id === matchSelected);

      if (rencontreSelected && rencontreSelected[0]) {
        return `${this._getRencontreTitle(rencontreSelected[0])} - ${rencontreSelected[0].date_rencontre}`;
      }
    }

    return label;
  }
  render() {
    const { isOpen } = this.state;
    const { headTitle, big } = this.props;

    const classNames = dynamicClassName('dropdown dropdown--match dropdown--select');
    isOpen && classNames.add('is-open');
    big && classNames.add('dropdown--big');

    return (
      <div className={classNames.build()} ref={this.setWrapperRef}>
        <span
          className="dropdown__head ft-h6 ft-up"
          onClick={this.handleClickDropDown}
          role='button'
          tabIndex={0}>
          {big && <span className="dropdown__subhead">{headTitle}</span>}
          <span className="dropdown__label">{this._renderLabel()}</span>
        </span>
        <div className="dropdown__list">
          <span
            className="dropdown__head ft-h6 ft-up"
            onClick={this.handleClickDropDown}
            role='button'
            tabIndex={0}>
            {big && <span className="dropdown__subhead">{headTitle}</span>}
            <span className="dropdown__label">{this._renderLabel()}</span>
          </span>
          <div className="dropdown__wrapper">{this._renderOptions()}</div>
        </div>
      </div>
    );
  }

  handleClickDropDown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  setWrapperRef = (node: any) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  handleSelected = (value: number) => {
    this.setState({ isOpen: false, matchSelected: value }, () => {
      const label = this._renderLabel();
      this.props.inputChanged(value, label);
    });
  };
}

export default DropdownMatch;
